import { render, staticRenderFns } from "./LiveTeamLayout.vue?vue&type=template&id=72467b9e&scoped=true"
import script from "./LiveTeamLayout.vue?vue&type=script&lang=ts"
export * from "./LiveTeamLayout.vue?vue&type=script&lang=ts"
import style0 from "./LiveTeamLayout.vue?vue&type=style&index=0&id=72467b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72467b9e",
  null
  
)

export default component.exports